module.exports = __webpack_public_path__ + "media/img/home/gallery/gallery7-f156f7ce50f300008c37ae3b53cc404c.png";